import {
  GET_NOTIFICATION,
  CLEAR_NOTIFICATION,
  CLEAR_NOTIFICATIONS,
  GET_ALL_NOTIFICATIONS,
  GET_NOTIFICATION_TYPES
} from "../constants/constants";

const initialState = { notifications: [], totalElements: 0, notification: {}, types: [] };

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_NOTIFICATIONS:
      return {
        ...state,
        notifications: [...action.payload.content],
        totalElements: action.payload.totalElements,
      };
    case GET_NOTIFICATION:
      return {
        ...state,
        notification: { ...action.payload },
      };
    case GET_NOTIFICATION_TYPES:
      return {
        ...state,
        types: [...action.payload]
      }
    case CLEAR_NOTIFICATION:
      return {
        ...state,
        notification: {},
      };
    case CLEAR_NOTIFICATIONS:
      return {
        ...state,
        notifications: [],
        totalElements: 0,
      };
    default:
      return state;
  }
};

export const getNotification = (state) => state.notificationReducer.notification;
export const getNotifications = (state) => state.notificationReducer.notifications;
export const getTotalElements = (state) => state.notificationReducer.totalElements;
export const getNotificationTypes = (state) => state.notificationReducer.types;
